import * as React from 'react';
import './landingpage.css';
import SearchBar from '../seachbar/SearchBar';
import FloodMap from '../googlemap/map/FloodMap';

const LandingPage = () => {
    const [coordinates,setCoordinates] = React.useState(null);
    const [address,setAddress] = React.useState(null);
    
      return(coordinates == null ? (
        
        <div  id="background">
          
          <img id="logo" alt="logo" src={require('../../assets/logo.png')}/>
          
          <p id="landing-page-title-text">Search for flood events around your property</p>
        
          <SearchBar setCoordinates={setCoordinates} setAddress={setAddress}/>
          
          <p  className="landing-page-text">Explore visual evidence of potential flood damages collected from imagery, news, and social media.</p>
          
          <p id="disclaimer">Disclaimer: Our catalog shows evidence of flooding at street level and does not quantify actual damage to the property.</p>
        
        </div>
      ) : (<FloodMap coordinates={coordinates} address={address}/>));
  
}

export default LandingPage;